import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const listBusinesses = (user) => async (dispatch) => {
    try {
        const { data } = await api.listBusinesses({ user });
       
        dispatch({
            type: Actions.LIST_BUSINESSES,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}